var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTest',{attrs:{"active":_vm.visible,"passed":_vm.count}},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.error)?_c('div',{staticClass:"mt-5 text-caption",domProps:{"innerHTML":_vm._s(_vm.error)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }